export const HashPrefix = {
    PROJECT: '10001',
    SHARE: '10002'
}
